import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';

var Telegram = function Telegram() {
  return /*#__PURE__*/_jsx("svg", {
    width: "20",
    height: "17",
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsx("path", {
      d: "M19.943 1.52695L16.9249 15.7604C16.6972 16.7649 16.1034 17.0149 15.2596 16.5417L10.6609 13.153L8.44199 15.2871C8.19643 15.5327 7.99105 15.738 7.5178 15.738L7.84819 11.0546L16.3713 3.353C16.7418 3.02262 16.2909 2.83957 15.7953 3.16995L5.25867 9.80447L0.72255 8.3847C-0.264145 8.07664 -0.282004 7.39801 0.927925 6.92475L18.6706 0.0893204C19.4921 -0.218743 20.2109 0.272372 19.943 1.52695Z",
      fill: "#2D9CDB"
    })
  });
};

export default Telegram;